<seds-modal>
  <div header>{{ labels.title }}</div>
  <div content>
    <p>
      {{ labels.text1 }}
      <b
        ><countdown
          #countdown
          [config]="{
            leftTime: leftTimeInSeconds,
            demand: true,
            format: 'mm:ss'
          }"
          (event)="handleEvent($event)"
        ></countdown>
        minutos</b
      >
      {{ labels.text2 }}
    </p>
  </div>
  <div class="footer w-100 d-flex justify-content-end" footer>
    <seds-outlined-button
      size="small"
      class="modal-user-idle__footer__btn-exit launch-event"
      data-testid="btn-sair"
      data-launch-site-section="Dashboard"
      data-launch-section="Clique"
      [attr.data-launch-label]="labels.button.exit"
      [title]="labels.button.exit"
      (click)="goToHomePage()"
    ></seds-outlined-button>
    <seds-basic-button
      size="small"
      id="renovateToken"
      data-testid="btn-ainda-estou-aqui"
      data-launch-site-section="Dashboard"
      data-launch-section="Clique"
      [attr.data-launch-label]="labels.button.label"
      [title]="labels.button.label"
      (click)="resetModalTimer()"
    ></seds-basic-button>
  </div>
</seds-modal>